import { type Action, type AsyncStateObject } from '../../../interfaces'
import { type FilteredCoacheListDto } from '../../../interfaces/users'
import { APP_ACTION_STATUS, COMMON_ACTIONS, USERS_ACTION_TYPE } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<FilteredCoacheListDto | null> = {
  data: null,
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const getAllCoachesReducer = (
  state = INITIAL_STATE,
  action: Action<FilteredCoacheListDto>
): AsyncStateObject<FilteredCoacheListDto | null> => {
  switch (action.type) {
    case USERS_ACTION_TYPE.GET_ALL_COACHES + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case USERS_ACTION_TYPE.GET_ALL_COACHES + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case USERS_ACTION_TYPE.GET_ALL_COACHES + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: null,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case USERS_ACTION_TYPE.GET_ALL_COACHES + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default getAllCoachesReducer
